module.exports = __webpack_public_path__ + "static/media/leave-remaining.78ed0f1e.jpg";